import { Navigate, Outlet, RouteObject } from "react-router";
import { CalculationParametersRoutePage } from "@/routes/base-data/processes/qpm/calculation-parameters/calculation-parameters-route-page";
import { CatalogListTablePage } from "@/routes/base-data/processes/qpm/catalog/catalog-list-table-page";
import { CatalogRoutePage } from "@/routes/base-data/processes/qpm/catalog/[catalogId]/catalog-route-page";
import { CatalogRoute } from "@/routes/base-data/processes/qpm/catalog/catalog-route";
import { CreateOrEditMonitorRoute } from "@/routes/base-data/processes/qpm/monitors/[monitorId]/create-or-edit-monitor-route";
import { BaseDataRoutePage } from "@/routes/base-data/processes/qpm/base-data/_components/base-data-route-page";
import { DocumentationsRoutePage } from "@/routes/base-data/processes/qpm/documentation/documentation-route-page";
import { MonitorsRoutePage } from "@/routes/base-data/processes/qpm/monitors/monitors-route-page";
import { MonitorsRoute } from "@/routes/base-data/processes/qpm/monitors/monitors-route";
import { CatalogMonitorRoutePage } from "@/routes/base-data/processes/qpm/catalog/[catalogId]/[monitorId]/catalog-monitor-route-page";
import { CertificatesRoutePage } from "@/routes/base-data/processes/qpm/certificates/certificates-route-page";
import { CompanyReferencesRoutePage } from "@/routes/base-data/processes/qpm/company-references/company-references-route-page";
import { OfferDataRoutePage } from "@/routes/base-data/processes/qpm/offer-data/offer-data-route-page";
import { ServiceProgramBaseDataRoutePage } from "@/routes/base-data/processes/qpm/service-program/service-program-base-data-route-page";

export const qpmBaseDataRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="catalog" replace />,
  },
  {
    path: "base-data",
    element: <BaseDataRoutePage />,
  },
  {
    path: "monitors",
    element: <MonitorsRoute />,
    children: [
      {
        index: true,
        element: <MonitorsRoutePage />,
      },
      {
        path: ":monitorId",
        element: <CreateOrEditMonitorRoute />,
      },
    ],
  },
  {
    path: "catalog",
    element: <CatalogRoute />,
    children: [
      {
        index: true,
        element: <CatalogListTablePage />,
      },
      {
        path: ":catalogId",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <CatalogRoutePage />,
          },
          {
            path: ":monitorId",
            element: <CatalogMonitorRoutePage />,
          },
        ],
      },
    ],
  },
  {
    path: "catalog/:catalogId",
    element: <CatalogRoutePage />,
  },
  {
    path: "documentations",
    element: <DocumentationsRoutePage />,
  },
  {
    path: "calculation-parameters",
    element: <CalculationParametersRoutePage />,
  },
  {
    path: "certificates",
    element: <CertificatesRoutePage />,
  },
  {
    path: "companyreferences",
    element: <CompanyReferencesRoutePage />,
  },
  {
    path: "offerdata",
    element: <OfferDataRoutePage />,
  },
  {
    path: "service-program",
    element: <ServiceProgramBaseDataRoutePage />,
  },
];
